(function () {

let $d9af53cf280b4a91$var$SCORE = 0;
function $d9af53cf280b4a91$var$getScoreDiv() {
    let scoreNode = document.getElementById("score-keeper");
    return scoreNode;
}
function $d9af53cf280b4a91$var$getScoreNode() {
    let scoreDiv = $d9af53cf280b4a91$var$getScoreDiv();
    return scoreDiv.children[0];
}
function $d9af53cf280b4a91$export$6c65d967fa3ec93() {
    let scoreNode = $d9af53cf280b4a91$var$getScoreNode();
    $d9af53cf280b4a91$var$SCORE += 1;
    scoreNode.innerHTML = $d9af53cf280b4a91$var$SCORE;
}
function $d9af53cf280b4a91$export$96d6c2d129a1da1d() {
    let scoreNode = $d9af53cf280b4a91$var$getScoreNode();
    $d9af53cf280b4a91$var$SCORE = 0;
    scoreNode.innerHTML = $d9af53cf280b4a91$var$SCORE;
}



let $c1e6dd3fd7d8fb03$var$COLLISION = false;
function $c1e6dd3fd7d8fb03$var$animateSnake() {
    if ($c1e6dd3fd7d8fb03$var$COLLISION) {
        (0, $d9af53cf280b4a91$export$96d6c2d129a1da1d)();
        (0, $d87fd232ffae7648$export$28c254c05623bf26)();
        (0, $d87fd232ffae7648$export$d13a71bbf24bf677)();
        $c1e6dd3fd7d8fb03$var$COLLISION = false;
        return;
    }
    let boundary = (0, $d87fd232ffae7648$export$1e3d33103e479235)();
    let snakeLen = (0, $d87fd232ffae7648$export$74a176e309663b56)();
    let direction = (0, $15bf6a3816abfb50$export$fcce7887255d1c69)();
    let SNAKEARRAY = (0, $d87fd232ffae7648$export$be10b7418aab95c7)();
    let head = SNAKEARRAY[SNAKEARRAY.length - 1];
    let headNode = $c1e6dd3fd7d8fb03$export$8ae20d19fcabfabc(head[0], head[1]);
    let headHTML = headNode.firstChild;
    for(let i = 0; i <= SNAKEARRAY.length - 2; i++){
        let node = $c1e6dd3fd7d8fb03$export$8ae20d19fcabfabc(SNAKEARRAY[i][0], SNAKEARRAY[i][1]);
        let nextNode = $c1e6dd3fd7d8fb03$export$8ae20d19fcabfabc(SNAKEARRAY[i + 1][0], SNAKEARRAY[i + 1][1]);
        SNAKEARRAY[i] = SNAKEARRAY[i + 1];
        let nodeChild;
        if (node.firstChild != null) nodeChild = node.firstChild;
        else {
            let cherryElement = document.createElement("p");
            cherryElement.innerHTML = "-";
            cherryElement.setAttribute("class", "snake-body");
            nodeChild = cherryElement;
        }
        nextNode.appendChild(nodeChild);
    }
    switch(direction){
        default:
            {
                // right
                // prevCoords[0] = (prevCoords[0] + 1) % boundary  
                let head = SNAKEARRAY[SNAKEARRAY.length - 1];
                let newHead = [
                    (head[0] + 1) % boundary,
                    head[1]
                ];
                let nextNode = $c1e6dd3fd7d8fb03$export$8ae20d19fcabfabc(newHead[0], newHead[1]);
                $c1e6dd3fd7d8fb03$var$COLLISION = (0, $d87fd232ffae7648$export$5528767febabf72a)(newHead);
                SNAKEARRAY[SNAKEARRAY.length - 1] = newHead;
                let cherryCoords = (0, $d87fd232ffae7648$export$a9b309f044870c05)(newHead);
                nextNode.innerHTML = "";
                nextNode.appendChild(headHTML);
                nextNode.firstChild.innerHTML = "<";
                // Extend after head has moved
                if (cherryCoords != null) (0, $d87fd232ffae7648$export$fad2c0902020cda5)(cherryCoords);
                break;
            }
        case "up":
            {
                let head = SNAKEARRAY[SNAKEARRAY.length - 1];
                let newHead = [
                    head[0],
                    (head[1] - 1 + boundary) % boundary
                ];
                let nextNode = $c1e6dd3fd7d8fb03$export$8ae20d19fcabfabc(newHead[0], newHead[1]);
                $c1e6dd3fd7d8fb03$var$COLLISION = (0, $d87fd232ffae7648$export$5528767febabf72a)(newHead);
                SNAKEARRAY[SNAKEARRAY.length - 1] = newHead;
                let cherryCoords = (0, $d87fd232ffae7648$export$a9b309f044870c05)(newHead);
                nextNode.innerHTML = "";
                nextNode.appendChild(headHTML);
                nextNode.firstChild.innerHTML = "v";
                if (cherryCoords != null) (0, $d87fd232ffae7648$export$fad2c0902020cda5)(cherryCoords);
                break;
            }
        case "left":
            {
                let head = SNAKEARRAY[SNAKEARRAY.length - 1];
                let newHead = [
                    (head[0] - 1 + boundary) % boundary,
                    head[1]
                ];
                let nextNode = $c1e6dd3fd7d8fb03$export$8ae20d19fcabfabc(newHead[0], newHead[1]);
                $c1e6dd3fd7d8fb03$var$COLLISION = (0, $d87fd232ffae7648$export$5528767febabf72a)(newHead);
                SNAKEARRAY[SNAKEARRAY.length - 1] = newHead;
                let cherryCoords = (0, $d87fd232ffae7648$export$a9b309f044870c05)(newHead);
                nextNode.innerHTML = "";
                nextNode.appendChild(headHTML);
                nextNode.firstChild.innerHTML = ">";
                if (cherryCoords != null) (0, $d87fd232ffae7648$export$fad2c0902020cda5)(cherryCoords);
                break;
            }
        case "down":
            {
                let head = SNAKEARRAY[SNAKEARRAY.length - 1];
                let newHead = [
                    head[0],
                    (head[1] + 1) % boundary
                ];
                let nextNode = $c1e6dd3fd7d8fb03$export$8ae20d19fcabfabc(newHead[0], newHead[1]);
                $c1e6dd3fd7d8fb03$var$COLLISION = (0, $d87fd232ffae7648$export$5528767febabf72a)(newHead);
                SNAKEARRAY[SNAKEARRAY.length - 1] = newHead;
                let cherryCoords = (0, $d87fd232ffae7648$export$a9b309f044870c05)(newHead);
                nextNode.innerHTML = "";
                nextNode.appendChild(headHTML);
                nextNode.firstChild.innerHTML = "^";
                if (cherryCoords != null) (0, $d87fd232ffae7648$export$fad2c0902020cda5)(cherryCoords);
                break;
            }
    }
}
function $c1e6dd3fd7d8fb03$export$592dbd515a49cf1b() {
    console.log("Starting animation");
    return setInterval($c1e6dd3fd7d8fb03$var$animateSnake, 200);
}
function $c1e6dd3fd7d8fb03$export$8ae20d19fcabfabc(x, y) {
    let bgItemsX = document.querySelectorAll(`[x=\'${x}\']`);
    for (let node of bgItemsX){
        if (node.getAttribute("y") == y) return node;
    }
}


let $15bf6a3816abfb50$var$DIRECTION = "right";
let $15bf6a3816abfb50$var$COORDSPRESSED = [];
function $15bf6a3816abfb50$export$42b24394061a3314() {
    document.addEventListener("keydown", (event)=>{
        // !Note: Registers when pressed once and held
        const key = event.key;
        if ((key == "ArrowUp" || key.toLowerCase() == "w") && $15bf6a3816abfb50$var$DIRECTION !== "down") $15bf6a3816abfb50$var$DIRECTION = "up";
        else if ((key == "ArrowDown" || key.toLowerCase() == "s") && $15bf6a3816abfb50$var$DIRECTION !== "up") {
            $15bf6a3816abfb50$var$DIRECTION = "down";
            console.log($15bf6a3816abfb50$var$DIRECTION);
            let headNode = document.getElementsByClassName("snake-head");
            headNode = headNode[0];
            let x = headNode.getAttribute("x");
            let y = headNode.getAttribute("y");
            $15bf6a3816abfb50$var$COORDSPRESSED.push([
                x,
                y
            ]);
        } else if ((key == "ArrowRight" || key.toLowerCase() == "d") && $15bf6a3816abfb50$var$DIRECTION !== "left") {
            $15bf6a3816abfb50$var$DIRECTION = "right";
            let headNode = document.getElementsByClassName("snake-head");
            headNode = headNode[0];
            let x = headNode.getAttribute("x");
            let y = headNode.getAttribute("y");
            $15bf6a3816abfb50$var$COORDSPRESSED.push([
                x,
                y
            ]);
        } else if ((key == "ArrowLeft" || key.toLowerCase() == "a") && $15bf6a3816abfb50$var$DIRECTION !== "right") {
            $15bf6a3816abfb50$var$DIRECTION = "left";
            let headNode = document.getElementsByClassName("snake-head");
            headNode = headNode[0];
            let x = headNode.getAttribute("x");
            let y = headNode.getAttribute("y");
            $15bf6a3816abfb50$var$COORDSPRESSED.push([
                x,
                y
            ]);
        }
    });
}
function $15bf6a3816abfb50$export$b218224b4df225dd() {
    let bgItems = document.getElementsByClassName("bg-item");
    let randomIndex = Math.floor(Math.random() * 100);
    while(bgItems[randomIndex].children.length > 1)randomIndex = Math.floor(Math.random * 100);
    return randomIndex;
}
function $15bf6a3816abfb50$export$f95d126819d028e5(x, y) {
    // ascend in value to the right and down from top left
    // using value of columns and rows
    // top left is 0,0
    return y * 10 + x;
}
function $15bf6a3816abfb50$export$59a2245ead134b72(index) {
    return [
        index % 10,
        Math.floor(index / 10)
    ];
}
function $15bf6a3816abfb50$export$fcce7887255d1c69() {
    return $15bf6a3816abfb50$var$DIRECTION;
}
function $15bf6a3816abfb50$export$91c5f51876550773() {
    $15bf6a3816abfb50$var$DIRECTION = "right";
}




let $d87fd232ffae7648$var$SNAKEBODYLEN = 3; //
let $d87fd232ffae7648$var$SNAKESTARTCOL = 3;
let $d87fd232ffae7648$var$SNAKESTARTROW = 4;
let $d87fd232ffae7648$var$SNAKEARRAY = [];
let $d87fd232ffae7648$var$cherryCoords = [];
const $d87fd232ffae7648$var$numberOfColsRows = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--number-of-cols-rows"));
function $d87fd232ffae7648$export$74a176e309663b56() {
    return $d87fd232ffae7648$var$SNAKEBODYLEN;
}
function $d87fd232ffae7648$export$1e3d33103e479235() {
    return $d87fd232ffae7648$var$numberOfColsRows;
}
function $d87fd232ffae7648$export$703a176a7b08c13a() {
    //  
    let gameContainer = document.getElementById("game-grid");
    for(let i = 0; i < $d87fd232ffae7648$var$numberOfColsRows ** 2; i++){
        let gridNode = document.createElement("div");
        gridNode.classList.add("bg-item");
        gridNode.setAttribute("x", i % $d87fd232ffae7648$var$numberOfColsRows);
        gridNode.setAttribute("y", Math.floor(i / 10));
        gameContainer.appendChild(gridNode);
    }
    return gameContainer;
}
function $d87fd232ffae7648$export$28c254c05623bf26() {
    let snakeItems = document.getElementsByClassName("snake-body");
    let i = 0;
    for (let snakeItem of snakeItems){
        console.log(snakeItem);
        let parent = snakeItem.parentElement;
        parent.removeChild(snakeItem);
        i++;
        console.log(`${i} nodes removed`);
    }
    let snakeHead = document.getElementsByClassName("snake-head");
    let parent = snakeHead[0].parentElement;
    parent.removeChild(snakeHead[0]);
    let cherries = document.getElementsByClassName("cherry");
    parent = cherries[0].parentElement;
    parent.removeChild(cherries[0]);
    $d87fd232ffae7648$var$SNAKEARRAY = [];
    (0, $15bf6a3816abfb50$export$91c5f51876550773)();
    $d87fd232ffae7648$export$5da742abfc97f4db();
}
function $d87fd232ffae7648$export$5da742abfc97f4db() {
    // 
    let snakeBody = "-";
    let snakeHead = "<";
    let snakeRow = $d87fd232ffae7648$var$SNAKESTARTROW;
    let snakeDiv = document.createElement("div");
    snakeDiv.setAttribute("class", "snake-body");
    let snakeItem;
    let bgItems = document.getElementsByClassName("bg-item");
    let currentBgDiv;
    for(let i = $d87fd232ffae7648$var$SNAKESTARTCOL; i < $d87fd232ffae7648$var$SNAKESTARTCOL + $d87fd232ffae7648$var$SNAKEBODYLEN; i++){
        currentBgDiv = bgItems[snakeRow * 10 + i];
        snakeItem = document.createElement("p");
        snakeItem.setAttribute("class", "snake-body");
        snakeItem.innerHTML = snakeBody;
        currentBgDiv.appendChild(snakeItem);
        snakeItem.style.setProperty("grid-column-start", `${i}`);
        $d87fd232ffae7648$var$SNAKEARRAY.push([
            i,
            $d87fd232ffae7648$var$SNAKESTARTROW
        ]);
    }
    currentBgDiv = bgItems[snakeRow * 10 + ($d87fd232ffae7648$var$SNAKEBODYLEN + $d87fd232ffae7648$var$SNAKESTARTCOL)];
    snakeItem = document.createElement("p");
    snakeItem.setAttribute("class", "snake-body");
    snakeItem.setAttribute("class", "snake-head");
    snakeItem.innerHTML = snakeHead;
    currentBgDiv.appendChild(snakeItem);
    snakeItem.style.setProperty("grid-column-start", $d87fd232ffae7648$var$SNAKEBODYLEN + $d87fd232ffae7648$var$SNAKESTARTCOL);
    $d87fd232ffae7648$var$SNAKEARRAY.push([
        $d87fd232ffae7648$var$SNAKEBODYLEN + $d87fd232ffae7648$var$SNAKESTARTCOL,
        $d87fd232ffae7648$var$SNAKESTARTROW
    ]);
    return snakeDiv;
}
function $d87fd232ffae7648$export$fad2c0902020cda5(newTail) {
    $d87fd232ffae7648$var$SNAKEARRAY.unshift(newTail);
}
function $d87fd232ffae7648$export$d13a71bbf24bf677() {
    let bgItems = document.getElementsByClassName("bg-item");
    let curIndex = (0, $15bf6a3816abfb50$export$b218224b4df225dd)();
    let cherry = document.createElement("p");
    cherry.setAttribute("class", "cherry");
    cherry.innerHTML = "*";
    bgItems[curIndex].appendChild(cherry);
    $d87fd232ffae7648$var$cherryCoords = (0, $15bf6a3816abfb50$export$59a2245ead134b72)(curIndex);
}
function $d87fd232ffae7648$export$30e2d9bef0818dc5() {
    let head = document.getElementsByClassName("snake-head")[0];
    let headX = head.parentElement.getAttribute("x");
    let headY = head.parentElement.getAttribute("y");
    let tailX, tailY;
    // TODO: check direction until a turn event ???
    let lastDir = (0, $15bf6a3816abfb50$export$fcce7887255d1c69)() ? (0, $15bf6a3816abfb50$export$fcce7887255d1c69)() : "right";
    if (lastDir == "right") {
        tailX = headX - $d87fd232ffae7648$var$SNAKEBODYLEN % 10;
        if (tailX < 0) tailX = $d87fd232ffae7648$var$numberOfColsRows + tailX;
        tailY = headY; // won't always be true 
    } else console.log("NOT YET HANDLED");
    return [
        [
            parseInt(headX),
            parseInt(headY)
        ],
        [
            parseInt(tailX),
            parseInt(tailY)
        ]
    ];
}
function $d87fd232ffae7648$export$be10b7418aab95c7() {
    return $d87fd232ffae7648$var$SNAKEARRAY ? $d87fd232ffae7648$var$SNAKEARRAY : [];
}
function $d87fd232ffae7648$export$da03f46e1126061b() {
    return $d87fd232ffae7648$var$cherryCoords;
}
function $d87fd232ffae7648$export$a9b309f044870c05(head) {
    if (head[0] == $d87fd232ffae7648$var$cherryCoords[0] && head[1] == $d87fd232ffae7648$var$cherryCoords[1]) {
        let oldCherryCoords = $d87fd232ffae7648$var$cherryCoords;
        (0, $d9af53cf280b4a91$export$6c65d967fa3ec93)();
        $d87fd232ffae7648$export$d13a71bbf24bf677();
        return oldCherryCoords;
    }
    return;
}
function $d87fd232ffae7648$export$5528767febabf72a(head) {
    for (let coord of $d87fd232ffae7648$var$SNAKEARRAY)if (head[0] === coord[0] && head[1] === coord[1]) {
        console.log("GAME OVER");
        (0, $d9af53cf280b4a91$export$96d6c2d129a1da1d)();
        return true;
    }
    return false;
}





(0, $d9af53cf280b4a91$export$96d6c2d129a1da1d)();
let $44ae6d9db4eaca0f$var$gameBoard = (0, $d87fd232ffae7648$export$703a176a7b08c13a)();
let $44ae6d9db4eaca0f$var$initialSnake = (0, $d87fd232ffae7648$export$5da742abfc97f4db)();
$44ae6d9db4eaca0f$var$gameBoard.appendChild($44ae6d9db4eaca0f$var$initialSnake);
(0, $d87fd232ffae7648$export$d13a71bbf24bf677)();
// Start game
// Define and register collision, inputs, sideeffects
(0, $15bf6a3816abfb50$export$42b24394061a3314)();
(0, $c1e6dd3fd7d8fb03$export$592dbd515a49cf1b)();

})();
//# sourceMappingURL=index.aea027ad.js.map
